import { Palette } from '../index';
import { palette } from "./palette";

export type NextButtonType = {
    nextButton: {
        fontFamily?: string,
        background: Palette | string,
        color: Palette | string,
        margin?: string,
    },
    nextButtonHovered: {
        background: Palette | string,
        color?: Palette | string,
    },
    nextButtonFocus: {
        background: Palette | string,
        color?: Palette | string,
        boxShadow?: string,
    },
    nextButtonDisabled: {
        cursor: string,
        pointerEvents: string,
        background: Palette | string,
        color: Palette | string,
    }
}

export const NextButtonStyles: NextButtonType = {
    nextButton: {
        background: '#EB731A',
        color: palette.white,
        margin: '20px 0',
    },
    nextButtonHovered: {
        background: '#CA5010',
    },
    nextButtonFocus: {
        background: '#CA5010',
    },
    nextButtonDisabled: {
        cursor: 'not-allowed',
        pointerEvents: 'none',
        background: palette.disabled_grey,
        color: palette.dark_grey,
    }
};
